import { Link } from "react-router-dom";

const LINKS = [
  { label: "Leistungen", id: "leistungen" },
  { label: "Ablauf", id: "ablauf" },
  { label: "Kontakt", id: "kontakt" },
];

export default function Footer() {
  const scrollTo = (id) =>
    document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });

  return (
    <footer
      data-testid="footer"
      className="bg-yx-surface border-t border-yx-border"
    >
      <div className="mx-auto max-w-7xl px-5 sm:px-8 py-20 sm:py-28">
        <h2 className="font-display font-extrabold tracking-tighter text-yx-primary text-5xl sm:text-7xl lg:text-8xl leading-[0.9] max-w-4xl">
          Lass uns wachsen.
        </h2>

        <div className="mt-16 grid grid-cols-1 sm:grid-cols-3 gap-10 border-t border-yx-border pt-10">
          <div>
            <img
              src="/yardtf-logo-transparent.png"
              alt="YardTF Gartenservice"
              className="h-12 w-auto object-contain mb-4"
            />
            <p className="text-sm text-yx-muted max-w-xs leading-relaxed">
              Ihr Gartenservice für Rasen, Hecken, Bäume und Pflanzen.
            </p>
          </div>

          <div>
            <p className="text-xs font-semibold uppercase tracking-[0.22em] text-yx-secondary mb-4">
              Navigation
            </p>
            <ul className="space-y-2">
              {LINKS.map((l) => (
                <li key={l.id}>
                  <button
                    data-testid={`footer-link-${l.id}`}
                    onClick={() => scrollTo(l.id)}
                    className="text-yx-text hover:text-yx-secondary transition-colors"
                  >
                    {l.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <p className="text-xs font-semibold uppercase tracking-[0.22em] text-yx-secondary mb-4">
              Kontakt
            </p>
            <a
              href="mailto:info.yardtf@gmail.com"
              data-testid="footer-email-link"
              className="block text-yx-text hover:text-yx-secondary transition-colors"
            >
              info.yardtf@gmail.com
            </a>
            <a
              href="tel:+4915229816526"
              data-testid="footer-phone-link"
              className="mt-1 block text-yx-text hover:text-yx-secondary transition-colors"
            >
              +49 (0) 1522 9816526
            </a>
          </div>
        </div>

        <div className="mt-14 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4 text-xs text-yx-muted">
          <p>© {new Date().getFullYear()} YardTF Gartenservice. Alle Rechte vorbehalten.</p>
          <div className="flex items-center gap-5">
            <Link
              to="/impressum"
              data-testid="footer-impressum-link"
              className="hover:text-yx-primary transition-colors"
            >
              Impressum
            </Link>
            <Link
              to="/admin"
              data-testid="footer-admin-link"
              className="hover:text-yx-primary transition-colors"
            >
              Admin
            </Link>
            <p>Mit Sorgfalt gepflegt.</p>
          </div>
        </div>
      </div>
    </footer>
  );
}
